import { safeLocalStorageProvider } from './../../providers/safeLocalStorageProvider'
import { warn } from './../../application/console'

const STORAGE_KEY = 'CurrentUser'

export class CurrentUser {
  get() {
    let currentUser = {}

    try {
      currentUser = safeLocalStorageProvider.get(STORAGE_KEY, {})
    } catch (e) {
      warn('failed loading/parsing user data from localStorage', e)
    }

    return currentUser
  }

  set(data) {
    safeLocalStorageProvider.set(STORAGE_KEY, data)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/currentUser/index.js